<main class="request-shell request-details-page">
  <app-landing-header />

  @if (isLoading) {
    <p class="details-state">{{ preferences.t('common.states.loading') }}</p>
  } @else if (errorMessage) {
    <p class="details-state is-error">{{ errorMessage }}</p>
  } @else if (details) {
    <section class="details-date">
      <span class="request-number">
        {{ preferences.t('myRequests.details.requestNumber') }} <strong dir="ltr">#{{ details.requestCode }}</strong>
      </span>
      <span class="request-date">
        <svg class="calendar-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        <span>{{ details.date }}</span>

      </span>
    </section>

    <section class="details-hero">
      <span class="bank-logo" [attr.title]="bankDisplayName()">
        <img
          [src]="logoImageUrl"
          [alt]="bankDisplayName() ?? ''"
          [attr.title]="bankDisplayName()"
          (error)="onLogoError($event)"
        />
      </span>
      <div>
        <h1>{{ details.offerTitle }}</h1>
        <p class="mt-2">
          {{ preferences.t('financeLabels.amountLabel') }}
          <strong class="money-value">
            <img src="/assets/images/global/riyal-icon.svg" alt="" />
            {{ details.amount }}
          </strong>
        </p>
      </div>
    </section>

    <section class="request-timeline">
      <p>
        <span class="timeline-hint-icon" aria-hidden="true">
          <img src="/assets/images/personal-fund/bill.png" alt="" />
        </span>
        {{ details.createdSinceText }}
      </p>
      <div class="timeline-dots" aria-hidden="true">
        @for (step of details.timelineSteps; track $index; let isLast = $last) {
          <span
            class="dot"
            [class.done]="step.isCompleted && !step.isCurrent && !step.isRejected"
            [class.current]="step.isCurrent"
            [class.rejected]="step.isRejected"
            [class.pending]="!step.isCompleted && !step.isCurrent && !step.isRejected"
            [attr.title]="step.name"
          >
            @if (step.isRejected) {
              <svg class="reject-icon" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 7M7 1L1 7" stroke="#ba1717" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            } @else if (step.isCompleted && !step.isCurrent) {
              <svg class="check-icon" width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 4.2L3.5 6.7L9 1.2" stroke="#289f5f" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            }
          </span>
          @if (!isLast) {
            <span class="timeline-line"></span>
          }
        }
      </div>
      <footer>
        <span
          class="request-status"
          [class.inprogress]="details.statusClass === 'inprogress'"
          [class.cancelled]="details.statusClass === 'cancelled'"
          [class.approved]="details.statusClass === 'approved'"
        >
          {{ details.status }}
        </span>
        <button type="button" (click)="openTrackingModal()">
          {{ preferences.t('myRequests.details.detailsLink') }}
          <app-icon name="chevron-left" />
        </button>
      </footer>
    </section>

    <section class="details-card">
      <header>
        <h2>{{ preferences.t('myRequests.details.title') }}</h2>
      </header>

      <div class="offer-summary">
        <span class="bank-logo" [attr.title]="bankDisplayName()">
          <img
            [src]="logoImageUrl"
            [alt]="bankDisplayName() ?? ''"
            [attr.title]="bankDisplayName()"
            (error)="onLogoError($event)"
          />
        </span>
        <h3>{{ details.offerTitle }}</h3>
      </div>

      <dl>
        @for (metric of metrics; track metric.label) {
          <div>
            <dt>{{ metric.label }}</dt>
            <dd>
              @if (metric.isMoney) {
                <span class="money-value">
                  <img src="/assets/images/global/riyal-icon.svg" alt="" />
                  {{ metric.value }}
                </span>
              } @else {
                {{ metric.value }}
              }
            </dd>
          </div>
        }
      </dl>

      <div class="contract-total">
        <span>{{ preferences.t('financeLabels.contractTotal') }}</span>
        <strong class="money-value">
          <img src="/assets/images/global/riyal-icon.svg" alt="" />
          {{ details.contractTotal }}
        </strong>
      </div>
    </section>

    <app-support-card
      titleKey="landing.support.title"
      descriptionKey="myRequests.details.supportHint"
      [contactEmail]="leadSupportEmail"
      [contactPhone]="leadSupportPhone"
      [disableAutoLoad]="true"
    />

    @if (isTrackingModalOpen) {
      <div class="edit-modal-backdrop" role="presentation" (click)="closeTrackingModal()">
        <div
          class="edit-modal tracking-modal"
          role="dialog"
          aria-modal="true"
          (click)="$event.stopPropagation()"
        >
          <span class="sheet-handle" aria-hidden="true"></span>

          <header class="edit-modal-header tracking-modal-header">
            <button
              type="button"
              class="edit-modal-close"
              (click)="closeTrackingModal()"
              [attr.aria-label]="preferences.t('common.actions.close')"
            >
              <app-icon [name]="preferences.language() === 'ar' ? 'chevron-right' : 'chevron-left'" />
            </button>
            <h2>{{ preferences.language() === 'ar' ? 'تفاصيل متابعة الطلب' : 'Request Tracking Details' }}</h2>
          </header>

          <div class="tracking-modal-body">
            @for (step of details.timelineSteps; track $index) {
              <div
                class="tracking-step-card"
                [class.is-done]="step.isCompleted && !step.isCurrent && !step.isRejected"
                [class.is-current]="step.isCurrent"
                [class.is-rejected]="step.isRejected"
                [class.is-pending]="!step.isCompleted && !step.isCurrent && !step.isRejected"
              >
              
                <div class="step-icon-wrap">
                  @if (step.isRejected) {
                    <span class="step-icon rejected">
                      <svg width="10" height="10" viewBox="0 0 8 8" fill="none">
                        <path d="M1 1L7 7M7 1L1 7" stroke="#ba1717" stroke-width="2" stroke-linecap="round"/>
                      </svg>
                    </span>
                  } @else if (step.isCompleted && !step.isCurrent) {
                    <span class="step-icon done">
                      <svg width="12" height="10" viewBox="0 0 10 8" fill="none">
                        <path d="M1 4.2L3.5 6.7L9 1.2" stroke="#289f5f" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </span>
                  } @else if (step.isCurrent) {
                    <span class="step-icon current"></span>
                  } @else {
                    <span class="step-icon pending"></span>
                  }
                </div>
                <div class="step-info">
                  <span class="step-title">{{ step.name }}</span>
                  @if (step.formattedDate) {
                    <span class="step-date">
                      <svg class="clock-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                      </svg>
                      {{ step.formattedDate }}
                    </span>
                  }
                </div>

              </div>
            }
          </div>
        </div>
      </div>
    }
  }
</main>
